var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5937 48.3686H68.8131L83.9027 29.3027C84.215 28.899 83.9332 28.3125 83.4228 28.3125H54.2109C53.9976 28.3125 53.792 28.4268 53.6853 28.6172L33.9492 62.7041C33.7131 63.1078 34.0025 63.6182 34.4748 63.6182H47.7591L40.9494 90.8572C40.8047 91.4514 41.5207 91.8703 41.9625 91.4437L86.0127 49.4121C86.4088 49.0389 86.1422 48.3686 85.5937 48.3686ZM49.8082 76.7959L54.4013 58.4385H42.4119L56.8541 33.4998H73.9623L58.0957 53.5559H74.1679L49.8082 76.7959Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59,
    stroke: "black",
    strokeDasharray: "20 20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChager);
export default __webpack_public_path__ + "static/media/chager.1fd05f03976e05eade33bb4cb86e3c1b.svg";
export { ForwardRef as ReactComponent };